import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import LinkTranslated from '@components/shared/LinkTranslated';
import NavigationSelected from '@images/vitals-navigation-selected.svg';

interface Props {
  link: string;
  title: string;
  count?: number;
  partiallyActive?: boolean;
}

const CategoryNavigationItem: React.FC<Props> = ({ link, title, count, partiallyActive }) => {
  if (count === 0) {
    return null;
  }

  return (
    <Container>
      <StyledLink to={link} activeClassName="active" partiallyActive={partiallyActive}>
        <NavigationSelected />
        <span>{title}</span>
      </StyledLink>
      {count && count > 0 && <ArticleCount>{count}</ArticleCount>}
    </Container>
  );
};

export default CategoryNavigationItem;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0 12px;
`;

const StyledLink = styled(LinkTranslated)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: BrownStd;
  font-size: 16px;
  line-height: 19px;
  color: ${Colors.forestGreen};
  border-bottom: 2px solid transparent;

  svg {
    display: none;
    margin-right: 10px;
  }

  &.active,
  &:hover {
    font-weight: 700;
    text-decoration: none;
    border-bottom-color: ${Colors.forestGreen};
  }

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 40px;
    letter-spacing: 0;
    border-bottom: 0;

    &.active {
      svg {
        display: inline-block;
      }
    }
  }
`;

const ArticleCount = styled.sup`
  font-family: BrownStd;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0;
  text-align: left;
  opacity: 0.5;
  color: ${Colors.forestGreen};
  margin-left: 4px;
`;
